const maxLength = (v, l) => v && v.length <= l;
const minLength = (v, l) => v && v.length >= l;

const validationMethods = {
    validation: {
        valueRequired: (v) => !!v,
        length: (v, l) => v && maxLength(v, l),
        emailLength: (v) => v && maxLength(v, 80),
        emailFormat: (v) => /^\w+([.-]\w+)*@\w+([.-]\w+)*\.\w{2,50}$/.test(v),
        mobileLength: (v) => v && maxLength(v, 20),
        mobileNumericLength: (v) => {
            const matches = v.match(/\d/g);
            return matches && matches.length <= 14;
        },
        anyNumerals: (v) => /\d+/.test(v),
        onlyNumerals: (v) => /^\d+$/.test(v),
        notSpecialCharacters: (v) => !/[&*+#><]/.test(v),
        passwordLength: (v) => minLength(v, 8),
        hasLowerOrUpperOrNumeral: (v) => /[a-zA-Z0-9]+/.test(v),
        hasLower: (v) => /[a-z]+/.test(v),
        hasUpper: (v) => /[A-Z]+/.test(v),
        valuesMatch: (v, v2) => v === v2,
        epostMinFilesSelected: (v) => v.length > 0,
        epostMaxFilesSelected: (v) => v.length <= 5, // number of selected files <= 5
        epostMaxTotalFileSize: (v) => (v.reduce((acc, i) => (acc += i.size), 0) / 1024 / 1024) <= 10, // aggregate file size <= 10MB
        epostIndividualFileSize: (v) => v.every((i) => i.size / 1024 / 1024 <= 10), // each file size <= 10MB
        epostFileExtension: (v) => {
            const validExtensions = ['.pdf','.jpg','.jpeg','.gif','.png','.bmp','.tiff','.tif'];
            let valid = true;
            for(const file of v){
                if(!validExtensions.some((ext) => file.name.toLowerCase().endsWith(ext))){
                    valid = false;
                }
                if(!valid){ 
                    break; 
                }
            }
            return valid;
        }
    },
    sanitisation: {
        removeLeadingZeros: (v) => typeof(v) === 'string' ? v.replace(/^0+/, '') : v,
        removeNonNumeric: (v) => typeof(v) === 'string' ? v.replace(/\D/g, '') : v,
        trim: (v) => typeof(v) === 'string' ? v.trim() : v
    }
};

export default validationMethods;
export const validation = validationMethods.validation;
export const sanitisation = validationMethods.sanitisation;
